<template>
  <label class="fs-7vh fw-700 c-deep position-relative line-63" style="z-index: 1; filter: drop-shadow(4px 6px 6px white);"
    >{{ labelHome }}</label
  >
  <img src="@/assets/img/new_qr_scan.gif" class="image-scanner" alt="" />
</template>
<script>
export default {
  props: {
    labelHome: {
      type: String,
      default: ''
    }
  }
}
</script>
<style>

</style>
